<template src="@/templates/reservations/flights-view.html"></template>


<script>
export default {
  props: [
    'flights',
  ],
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// flights-view.vue?097b41ea